export const QUALITIES = `
  __typename
  id
  name
`;

export const ORGANIZATION = `
  __typename
  color
  name
  id
  givePrivacyDisclaimerBody
  givePrivacyDisclaimerTitle
  customUserTerms
  defaultNoBadgePoints
  defaultNoBadgePointsLocked
  pointsEnabled
  gmEnabled
  fbEnabled
  stickersEnabled
  kudosAttachmentsEnabled
  badgesEnabled
  url
  qualities {
    ${QUALITIES}
  }
`;

export const USER = `
  __typename
  name
  avatar
  id
  email
  organization {
    ${ORGANIZATION}
  }
  person {
    __typename
    locale
  }
  country
  pointsBalance
  canGiveKudosAward
  pointsToGive
  canSendToGroups
  rewardsEnabled
  pointsEnabled
  stickersEnabled
  kudosAttachmentsEnabled
  allowPrivateMessages
  restrictPointsToBadges
`;

export const WALL_USER = `
  __typename
  id
  name
  avatar
`;

export const AUTO_COMPLETE_USERS = `
  __typename
  id
  name
  type
  description
  avatar
`;

export const KUDOS = `
  __typename
  id
  message
`;

export const HASHTAG = `
  name
`;

export const ATTACHMENT = `
  url
  id
`;

export const ALBUM_ITEM = `
  url
  id
`;

export const KUDOS_VALUE = `
  name
  id
`;

export const KUDOS_BADGE = `
  imagePath
  name
`;

export const OUTSIDE_USER = `
  id
  name
`;

export const GROUP = `
  id
  avatar
  name
`;

export const COMMENT = `
  id
  body
  canReact
  hashtags {
    ${HASHTAG}
  }
  reactionCount
  createdAt
  user {
    ${WALL_USER}
  }
  carbonCopied {
    name
    id
  }
`;

export const EVENT = `
  id
  title
  anniversaryYears
  description
  comments {
    ${COMMENT}
  }
  eventType
  user {
    ${WALL_USER}
  }
  createdAt
  commentCount
`;

export const ANNOUNCEMENT = `
  id
  announcement
  richAnnouncement
  attachments {
    ${ATTACHMENT}
  }
  comments{
    ${COMMENT}
  }
  timeAgo
  createdAt
  commentCount
`;

export const ALBUM = `
  id
  type
  url
  items {
    ${ALBUM_ITEM}
  }
  title
  isLiked
  description
  commentCount
  reactionCount
  createdAt
  comments {
    ${COMMENT}
  }
`;

export const PAGE = `
  slug
  type
  url
  title
  timeAgo
  contentPreview
  createdAt
  imagePreview
`;

export const KUDOS_AWARD = `
  id
  public
  level
  attachments{
    ${ATTACHMENT}
  }
  kplusCount
  canKplus
  canMakePrivate
  kplussers {
    ${USER}
  }
  kudosValues {
    ${KUDOS_VALUE}
  }
  badge {
    ${KUDOS_BADGE}
  }
  message
  recipients {
    __typename
    ... on Kudos {
      ${WALL_USER}
    }
    ... on Outside {
      ${OUTSIDE_USER}
    }
  }
  groups {
    ${GROUP}
  }
  sender {
    ${WALL_USER}
  }
  timeAgo
  comments {
    ${COMMENT}
  }
  commentCount
  createdAt
  ccers {
    id
    name
  }
  stickers {
    name
    imageUrl
  }
`;
